const createMessageString = function (errors) {
  let errorHtml = ''
  errors.forEach((error) => {
    errorHtml += `<p>${error}</p>`
  })
  return errorHtml
}
export default createMessageString
